import cn from 'classnames';
import { DictType } from 'core-lib/types/Helper';
import s from './Shimmer.module.scss';

type ShimmerProps = {
  rootStyle?: DictType;
};

export const Shimmer = ({ rootStyle = {} }: ShimmerProps) => {
  return (
    <div className={s.shimmer} style={rootStyle}>
      <div className={cn(s.top, 'cmn_shimmer')} />
      <div className={s.bottom}>
        <div className="cmn_shimmer" />
        <div className="cmn_shimmer" />
        <div className={cn(s.subtitle, 'cmn_shimmer')} />
        <div className="cmn_shimmer" />
      </div>
    </div>
  );
};
